import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsService } from 'ngx-permissions';
import { delay } from 'rxjs/operators';
import { HelpDialogComponent } from '../../_components/help-dialog/help-dialog.component';
import { OrganizationService } from '../../_services/organization.service';

class NestedTab {
  description: string;
  path: string;
  icon: string;
  permissions: string[];
  action?: string;
}
class CustomSidebar extends NestedTab {
  id: string;
  submenu?: NestedTab[];

  constructor() {
    super();
  }
}

@Component({
  selector: 'app-sidebar-menu-component',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss'],
})
export class SidebarMenuComponent implements OnInit, AfterViewInit {
  @Input() sidebarMenu: CustomSidebar;
  @Input() activeNav: any;
  @Input() barIsCollapsed: any;
  @Output() activeNavChange = new EventEmitter<string>();

  routerService: Router;
  availableTabs: string[] = [];
  highlightParent: boolean;

  public permissionsLoaded: boolean = false;
  private closeTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private router: Router,
    private ngxPermissionService: NgxPermissionsService,
    public organizationService: OrganizationService,
    public modalService: NgbModal
  ) {
    this.routerService = router;
  }

  ngOnInit(): void {
    this.listenToPermissions();
  }

  ngAfterViewInit() {
    if (this.sidebarMenu.submenu) {
      this.availableTabs = this.sidebarMenu.submenu.map(tab => tab.path);
      this.routerService.events.subscribe(nav => {
        if (nav instanceof NavigationEnd) {
          this.updateNavigationSettings(nav.url);
        }
      });
      setTimeout(() => this.updateNavigationSettings(this.routerService.url));
    }
  }

  private updateNavigationSettings(pathUrl) {
    this.activeNav = '';
    this.highlightParent = this.availableTabs.indexOf(pathUrl) !== -1;
    if (this.highlightParent && !this.barIsCollapsed) {
      this.activeNav = this.sidebarMenu.path;
      this.activeNavChange.emit(this.activeNav);
    }
  }

  toggleNavStatusActiveNav() {
    if (!this.barIsCollapsed) {
      this.activeNav =
        this.activeNav === this.sidebarMenu.path ? '' : this.sidebarMenu.path;
      this.activeNavChange.emit(this.activeNav);
    }
  }

  private listenToPermissions(): void {
    this.organizationService.permissionsLoaded
      .pipe(delay(0))
      .subscribe(isLoaded => {
        this.permissionsLoaded = isLoaded;
      });
  }

  public menuAction(action: string): void {
    if (action == 'trainingAction') {
      this.openTrainingDialog();
    }
  }

  public openOnHover(dropdown: NgbDropdown): void {
    this.cancelClose();
    dropdown.open();
  }

  public scheduleClose(dropdown: NgbDropdown, delayMs: number = 30): void {
    this.cancelClose();
    this.closeTimer = setTimeout(() => dropdown.close(), delayMs);
  }

  public cancelClose(): void {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }

  public openTrainingDialog(): void {
    const modalRef = this.modalService.open(HelpDialogComponent, {});
    modalRef.componentInstance.type = 'training';

    modalRef.result.then(data => {
      if (data) {
      }
    });
  }
}
